import React from 'react';

import {AppContext} from '../../../AppModule/Context';

import AnimatedSvgLogo from '../../common/genericComponents/animatedSvgLogo';
import ButtonComponent from '../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import CommunicationIcons from '../../../assets/svgComponents/communicationIcons';

import VIDABOO_CONSTANTS from '../../../config/consts';
import whatsapp from '../../../assets/svg/whatsapp-redesign.svg';

import './whatsappComponent.css';

class WhatsappComponent extends React.Component {
  constructor() {
    super();
  }

  sendWhatsappMessage = () => {
    this.props.sendGA(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.SEND_WHATSAPP_MESSAGE,
    );
    this.props.dispatchConsoltoEvents(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.SEND_WHATSAPP_MESSAGE,
    );
    let text = encodeURI('Hi, I saw your website and wanted to ask...');
    if (this.props.mentor.mentorDto.appControlDto.whatsappInitialMessage) {
      text = encodeURI(
        this.props.mentor.mentorDto.appControlDto.whatsappInitialMessage,
      );
    }

    let mentorPhoneNumber = this.props.mentor.mentorDto.whatsappPhoneNumber;
    if (mentorPhoneNumber && mentorPhoneNumber[0] !== '+') {
      mentorPhoneNumber = '+' + mentorPhoneNumber;
    }
    // var mentorPhoneNumber = 8401655455
    window.open(
      'https://api.whatsapp.com/send?phone=' +
        mentorPhoneNumber +
        '&text=' +
        text,
      '_blank',
    );
  };

  render() {
    return (
      <div
        className={
          this.props.isPersonalPage
            ? 'et-personal-page-right-content-wrap'
            : 'et-widget-body-content-wrap'
        }>
        <div
          className={`et-v2-whatsapp-container ${this.props.isPersonalPage ? 'et-v2-pp-whatsapp-container' : ''}`}>
          <div
            className="et-v2-whatsapp-icon-text-wrap"
            onClick={() => {
              this.sendWhatsappMessage();
              this.props.callSendMessageFunc(
                'Whatsapp message',
                VIDABOO_CONSTANTS.CHAT_SUBTYPES.WHATSAPP_MESSAGE,
              );
            }}>
            {this.props.showNewUI ? (
              <div className="et-v2-whatsapp-animated-svg-logo-wrap">
                <AnimatedSvgLogo
                  type={VIDABOO_CONSTANTS.ANIMATED_SVG_LOGO_TYPES.WHATSAPP}
                />
              </div>
            ) : (
              <img
                className="et-v2-wc-icon-img"
                src={whatsapp}
                alt="whatsapp-icon"
              />
            )}
            <div className="et-v2-whatsapp-inner-txt">
              {(this.props.mentor.mentorDto.appControlDto.widgetEditableTexts &&
                this.props.mentor.mentorDto.appControlDto.widgetEditableTexts[
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WHATSAPP
                ]) || (
                <>
                  Let's start <br /> Whatsapp chat
                </>
              )}
            </div>
          </div>
        </div>
        <div
          className={`et-v2-widget-btn-wrap ${this.props.isPersonalPage ? 'et-v2-clickntalk-btn-wrap' : ''}`}>
          <ButtonComponent
            onClick={() => {
              this.sendWhatsappMessage();
              this.props.callSendMessageFunc(
                'Whatsapp message',
                VIDABOO_CONSTANTS.CHAT_SUBTYPES.WHATSAPP_MESSAGE,
              );
            }}
            image={
              this.props.isPersonalPage ? (
                <div className="et-v2-whatsapp-btn-img">
                  <CommunicationIcons.WhatsappIcon fillColor="#fff" size={40} />
                </div>
              ) : null
            }
            text={
              (this.props.mentor.mentorDto.appControlDto.widgetEditableTexts &&
                this.props.mentor.mentorDto.appControlDto.widgetEditableTexts[
                  VIDABOO_CONSTANTS.WIDGET_APP_CTA_TYPES_BTN_TEXT.WHATSAPP
                ]) ||
              this.context.languageSet.CONSOLTO_WIDGET.START_CHAT
            }
          />
        </div>
      </div>
    );
  }
}

WhatsappComponent.contextType = AppContext;
export default WhatsappComponent;
